/**
 * ForaVida Inmeettool – Terrasoverkapping v1.1.0
 *
 * Client-side calculation engine for patio cover measurements.
 * Shared helpers loaded from FviHelpers (foravida-fvi-helpers.js).
 *
 * @package ForaVida_Inmeettool
 */
( function () {
	'use strict';

	var H = window.FviHelpers;

	// ===== i18n =====
	var i18n = ( typeof fviOverkappingData !== 'undefined' && fviOverkappingData.i18n ) ? fviOverkappingData.i18n : {};
	var t = function ( key, fallback ) { return i18n[ key ] || fallback || key; };

	var W = new WeakMap();
	var PLACEHOLDER = '<p class="fvi-placeholder">' + t( 'placeholder' ) + '</p>';

	// ===== Data =====
	var stdB = [ 3.03, 4.03, 5.03, 6.03, 7.03, 8.03, 9.03, 10.03, 11.03, 12.03 ];
	var stdD = [ 2.5, 3.0, 3.5, 4.0 ];

	var polyPlateCount  = function ( Bm ) { return Math.round( Bm ); };
	var glassPlateCount = function ( Bm ) { return Math.round( Bm ); };

	var Dmm  = { 2.5: 2483.12, 3.0: 2980.76, 3.5: 3475.89, 4.0: 3970.98 };
	var dHH1 = { 2.5: 349.0, 3.0: 418.9, 3.5: 488.5, 4.0: 558.1 };

	var skuPrefix = function ( dak ) { return dak === 'glas' ? 'XLTG' : 'XLTP'; };
	var widthCode = function ( b )   { return String( Math.round( b * 10 ) ); };
	var depthCode = function ( d )   { return String( Math.round( d * 10 ) ); };

	var COLORS = [
		{ kleur: 'B', label: t( 'colorMatzwart' ),  swatch: 'fvi-swatch--black' },
		{ kleur: 'A', label: t( 'colorAntraciet' ), swatch: 'fvi-swatch--anthracite' },
		{ kleur: 'W', label: t( 'colorMatWit' ),    swatch: 'fvi-swatch--white' }
	];

	// ===== Core functions =====
	function state( root ) {
		if ( ! W.has( root ) ) { W.set( root, { versie: 'zonder', skuBase: null } ); }
		return W.get( root );
	}

	function setTabs( root ) {
		var tabs = root.querySelectorAll( '[data-fvi="tab"]' );
		var s = state( root );
		for ( var i = 0; i < tabs.length; i++ ) {
			tabs[ i ].setAttribute( 'aria-selected', String( s.versie === tabs[ i ].getAttribute( 'data-fvi-mode' ) ) );
		}
	}

	function chooseB( effBm, versie ) {
		var i;
		if ( versie === 'met' ) {
			for ( i = 0; i < stdB.length; i++ ) {
				if ( stdB[ i ] >= effBm - 1e-9 ) { return stdB[ i ]; }
			}
			return stdB[ stdB.length - 1 ];
		}
		for ( i = stdB.length - 1; i >= 0; i-- ) {
			if ( stdB[ i ] <= effBm + 1e-9 ) { return stdB[ i ]; }
		}
		return stdB[ 0 ];
	}

	function adviseDepth( mm ) {
		var m = mm / 1000, out = stdD[ 0 ];
		for ( var i = 0; i < stdD.length; i++ ) {
			if ( stdD[ i ] <= m ) { out = stdD[ i ]; }
		}
		return out;
	}

	var prevStdB = function ( Bm ) {
		var i = stdB.indexOf( Bm );
		return i > 0 ? stdB[ i - 1 ] : null;
	};

	function calcRow( label, value ) {
		return '<div class="fvi-calc-row">' +
			'<span class="fvi-calc-label">' + label + '</span>' +
			'<span class="fvi-calc-value">' + value + '</span></div>';
	}

	// ===== Calculation =====
	function calc( root ) {
		var s = state( root );
		var breedte   = Number( root.querySelector( '[data-fvi="breedte"]' ).value || 0 );
		var diepteMm  = Number( root.querySelector( '[data-fvi="diepte"]' ).value || 0 );
		var dak       = root.querySelector( '[data-fvi="daktype"]' ).value;
		var tweeMuren = root.querySelector( '[data-fvi="tussenmuren"]' ).value === 'ja';
		var H1        = Number( root.querySelector( '[data-fvi="h1"]' ).value || 0 );

		if ( ! breedte || ! diepteMm ) {
			H.showError( root, t( 'fillMinimum' ) );
			return;
		}
		if ( breedte < 1000 || breedte > 15000 ) {
			H.showError( root, t( 'widthRange' ) );
			return;
		}
		if ( diepteMm < 2000 || diepteMm > 5000 ) {
			H.showError( root, t( 'depthRange' ) );
			return;
		}
		if ( H1 && ( H1 < 1900 || H1 > 4000 ) ) {
			H.showError( root, t( 'heightRange' ) );
			return;
		}

		var spelingMm = tweeMuren ? ( breedte / 1000 ) * 2 : 0;
		var effBmm    = breedte - spelingMm;
		var effBm     = effBmm / 1000;

		var Bm = chooseB( effBm, s.versie );
		var Dd = adviseDepth( diepteMm );
		var D  = Dmm[ Dd ];

		var delta = dHH1[ Dd ];
		var HVal  = H1 ? ( H1 + delta ) : null;

		// Inkorten logic.
		var inkortHtml = '';
		if ( s.versie === 'met' ) {
			var X = Math.max( 0, ( Bm * 1000 ) - effBmm );

			if ( dak === 'poly' ) {
				if ( X > 0 ) {
					var nPoly = polyPlateCount( Bm );
					inkortHtml =
						'<div class="fvi-ok" style="margin-top:.75rem">' +
						'<strong>' + t( 'shortenPolyHeading' ) + '</strong>' +
						'<ul class="fvi-list">' +
						'<li>' + t( 'shortenProfiles' ).replace( '%s', '<strong>' + H.fmt( X ) + '</strong>' ) + '</li>' +
						'<li>' + t( 'dividePlates' ) + '<ul>' +
						'<li>' + t( 'oneSideShorten' ).replace( '%s', '<strong>' + H.fmt( X ) + '</strong>' ) + '</li>' +
						'<li>' + t( 'twoSidesShorten' ).replace( '%s', '<strong>' + H.fmt( Math.round( X / 2 ) ) + '</strong>' ) + '</li>' +
						'<li>' + t( 'equalDivision' ).replace( '%1$s', '<strong>' + H.fmt( Math.round( X / nPoly ) ) + '</strong>' ).replace( '%2$d', nPoly ) + '</li>' +
						'</ul></li></ul></div>';
				}
			} else {
				if ( X > 0 ) {
					var nPanels = glassPlateCount( Bm );
					var maxCut  = 80 * nPanels;
					var is80    = X % 80 === 0;

					if ( X <= maxCut && is80 ) {
						var steps = X / 80;
						inkortHtml =
							'<div class="fvi-ok" style="margin-top:.75rem">' +
							'<strong>' + t( 'shortenGlassHeading' ) + '</strong><ul>' +
							'<li>' + t( 'replaceGlassPlates' ).replace( '%d', '<strong>' + steps + '</strong>' ) + '</li>' +
							'<li>' + t( 'shorteningSummary' ).replace( '%1$s', '<strong>' + H.fmt( X ) + '</strong>' ).replace( '%2$s', '<strong>' + H.fmt( maxCut ) + '</strong>' ).replace( '%3$d', nPanels ) + '</li>' +
							'</ul></div>';
					} else if ( X <= maxCut ) {
						var stepsUp = Math.ceil( X / 80 );
						var cut     = stepsUp * 80;
						var Bgoal   = Math.round( ( Bm * 1000 ) - cut );
						inkortHtml =
							'<div class="fvi-warn" style="margin-top:.75rem">' +
							t( 'notMultiple80' ).replace( '%1$s', '<strong>' + H.fmt( X ) + '</strong>' ).replace( '%2$s', '<strong>' + H.nf2( Bm ) + '</strong>' ) +
							'<br>' + t( 'adviceReplace' ).replace( '%1$d', '<strong>' + stepsUp + '</strong>' ).replace( '%2$s', '<strong>' + H.fmt( cut ) + '</strong>' ) +
							'<br><strong>' + t( 'newEffectiveWidth' ).replace( '%s', H.fmt( Bgoal ) ) + '</strong></div>';
					} else {
						var Bfallback = prevStdB( Bm );
						if ( Bfallback ) {
							var prevText = H.nf2( Bm );
							Bm = Bfallback;
							inkortHtml =
								'<div class="fvi-warn" style="margin-top:.75rem">' +
								t( 'shorteningTooLarge' ).replace( '%1$s', '<strong>' + H.fmt( X ) + '</strong>' ).replace( '%2$s', '<strong>' + H.fmt( maxCut ) + '</strong>' ).replace( '%3$s', '<strong>' + prevText + '</strong>' ) +
								'<br>' + t( 'adviceChooseWidth' ).replace( '%s', '<strong>' + H.nf2( Bm ) + '</strong>' ) + '</div>';
						} else {
							inkortHtml =
								'<div class="fvi-warn" style="margin-top:.75rem">' +
								t( 'notPossibleGlass' ) + '</div>';
						}
					}
				}
			}
		}

		// SKU base.
		s.skuBase = skuPrefix( dak ) + widthCode( Bm ) + depthCode( Dd );

		// Build result header with print/copy icons.
		var header =
			'<div class="fvi-card__header">' +
			'<span class="fvi-card__title">' + t( 'resultTitle' ) + '</span>' +
			'<div class="fvi-card__actions">' +
			'<button class="fvi-btn fvi-btn--icon" data-fvi-action="print" title="' + t( 'printTitle' ) + '">' + H.ICON_PRINT + '</button>' +
			'<button class="fvi-btn fvi-btn--icon" data-fvi-action="copy" title="' + t( 'copyTitle' ) + '">' + H.ICON_COPY + '</button>' +
			'</div></div>';

		var uM  = ' ' + t( 'unitM' );
		var uMm = ' ' + t( 'unitMm' );

		// Build calc-style result rows.
		var rows =
			'<div class="fvi-calc-list">' +
			calcRow( t( 'rowProductWidth' ), H.nf2( Bm ) + uM ) +
			calcRow( t( 'rowDepthAdvice' ), H.nf1( Dd ) + uM ) +
			calcRow( t( 'rowWallDistance' ), H.fmt( D ) + uMm ) +
			calcRow( t( 'rowGutterHeight' ), H1 ? H.fmt( H1 ) + uMm : '\u2014' ) +
			calcRow( t( 'rowWallHeight' ), HVal ? H.fmt( HVal ) + uMm : '\u2014' ) +
			'</div>';

		// KPI summary.
		var versionLabel = s.versie === 'met'
			? t( 'versionWithShorten' ) + ' (\u2191)'
			: t( 'versionWithoutShorten' ) + ' (\u2193)';
		var kpi =
			'<div class="fvi-calc-list" style="margin-top:.75rem">' +
			calcRow( t( 'rowEffectiveWidth' ), H.fmt( effBmm ) + uMm ) +
			calcRow( t( 'rowVersion' ), versionLabel ) +
			'</div>';

		// Color selection chips.
		var colorHtml = '';
		var chips = '';
		for ( var ci = 0; ci < COLORS.length; ci++ ) {
			var c = COLORS[ ci ];
			chips +=
				'<button type="button" class="fvi-chip" data-fvi-kleur="' + c.kleur + '">' +
				'<span class="fvi-swatch ' + c.swatch + '"></span>' + c.label + '</button>';
		}
		colorHtml =
			'<div class="fvi-color-section">' +
			'<span class="fvi-overline">' + t( 'colorPickHeading' ) + '</span>' +
			'<div class="fvi-choice">' + chips + '</div>' +
			'<p class="fvi-footer">' + t( 'colorPickFooter' ) + '</p>' +
			'</div>';

		root.querySelector( '[data-fvi="result"]' ).innerHTML =
			header + rows + kpi + inkortHtml + colorHtml;
	}

	function reset( root ) {
		var fields = [ 'breedte', 'diepte', 'h1' ];
		for ( var i = 0; i < fields.length; i++ ) {
			var el = root.querySelector( '[data-fvi="' + fields[ i ] + '"]' );
			if ( el ) { el.value = ''; }
		}

		var selects = [ 'daktype', 'tussenmuren' ];
		for ( var j = 0; j < selects.length; j++ ) {
			var sel = root.querySelector( '[data-fvi="' + selects[ j ] + '"]' );
			if ( sel ) { sel.selectedIndex = 0; }
		}

		var s     = state( root );
		s.versie  = 'zonder';
		s.skuBase = null;
		setTabs( root );

		root.querySelector( '[data-fvi="result"]' ).innerHTML = PLACEHOLDER;
	}

	function copyResult( root ) {
		H.copyToClipboard( root, t, { normalizeNewlines: true } );
	}

	function printResult( root ) {
		H.printContent( root, t,
			'.fvi-calc-list{display:flex;flex-direction:column}' +
			'.fvi-calc-row{display:flex;justify-content:space-between;align-items:flex-end;padding:8px 0;border-bottom:1px solid rgba(222,192,180,0.3);font-size:12px}' +
			'.fvi-calc-row:last-child{border-bottom:none}' +
			'.fvi-calc-label{color:#574239}' +
			'.fvi-calc-value{font-weight:700;color:#3d441e}'
		);
	}

	function gotoProduct( root, kleur ) {
		var s = state( root );
		if ( ! s.skuBase ) {
			H.showError( root, t( 'calcFirst' ) );
			return;
		}
		window.location.href = '/?s=' + encodeURIComponent( s.skuBase + kleur ) + '&post_type=product';
	}

	// ===== Initialization =====
	function init( root ) {
		if ( ! root || root.dataset.fviReady === '1' ) { return; }
		root.dataset.fviReady = '1';

		root.addEventListener( 'click', function ( e ) {
			var tab = e.target.closest( '[data-fvi="tab"]' );
			if ( tab && root.contains( tab ) ) {
				e.preventDefault();
				state( root ).versie = tab.getAttribute( 'data-fvi-mode' ) === 'met' ? 'met' : 'zonder';
				setTabs( root );
				return;
			}

			var act = e.target.closest( '[data-fvi-action]' );
			if ( act && root.contains( act ) ) {
				e.preventDefault();
				var a = act.getAttribute( 'data-fvi-action' );
				if ( a === 'calc' )  { calc( root ); }
				if ( a === 'reset' ) { reset( root ); }
				if ( a === 'copy' )  { copyResult( root ); }
				if ( a === 'print' ) { printResult( root ); }
				return;
			}

			var kleurBtn = e.target.closest( '[data-fvi-kleur]' );
			if ( kleurBtn && root.contains( kleurBtn ) ) {
				e.preventDefault();
				gotoProduct( root, kleurBtn.getAttribute( 'data-fvi-kleur' ) );
			}
		}, true );

		// WCAG 2.1 SC 2.1.1 — keyboard navigation for role="tablist"
		root.addEventListener( 'keydown', function ( e ) {
			var tablist = e.target.closest( '[role="tablist"]' );
			if ( ! tablist || ! root.contains( tablist ) ) { return; }
			var tabs = Array.prototype.slice.call( tablist.querySelectorAll( '[data-fvi="tab"]' ) );
			if ( ! tabs.length ) { return; }
			var idx = tabs.indexOf( document.activeElement );
			if ( idx === -1 ) { return; }
			var next = idx;
			if ( e.key === 'ArrowRight' ) {
				next = ( idx + 1 ) % tabs.length;
			} else if ( e.key === 'ArrowLeft' ) {
				next = ( idx - 1 + tabs.length ) % tabs.length;
			} else if ( e.key === 'Home' ) {
				next = 0;
			} else if ( e.key === 'End' ) {
				next = tabs.length - 1;
			} else {
				return;
			}
			e.preventDefault();
			tabs[ next ].focus();
			state( root ).versie = tabs[ next ].getAttribute( 'data-fvi-mode' ) === 'met' ? 'met' : 'zonder';
			setTabs( root );
		} );

		reset( root );
	}

	function initAll() {
		var roots = document.querySelectorAll( '.fvi-inmeettool[data-fvi="root"]:not([data-fvi-tool])' );
		for ( var i = 0; i < roots.length; i++ ) { init( roots[ i ] ); }
	}

	H.ready( initAll );
	H.debounceObserver( initAll );
} )();
